const styles = () => ({
  overviewContainer: {
    margin: '8vh 0'
  },
  themePreviewContainer: { display: 'flex' },
  themePaletteContainer: { marginRight: '20px' }
});

export default styles;
